// extracted by mini-css-extract-plugin
export var card = "blog-module--card--+4V+q";
export var cardTop = "blog-module--cardTop--0Iyma";
export var date = "blog-module--date--su1aj";
export var excerpt = "blog-module--excerpt--J--nv";
export var link = "blog-module--link--+P2ju";
export var listingSection = "blog-module--listingSection--AsrFM";
export var postsGrid = "blog-module--postsGrid--GHr7c";
export var title = "blog-module--title--4KmjG";